import { Directive, Input } from '@angular/core';
import { ElementRef } from "@angular/core";


@Directive({
    selector: '[focus]'
})
export class SetFocusDirective {

    @Input()
    set focus(value) {
        if (value) {
            this.el.nativeElement.focus();
        }
    }

    constructor(private el: ElementRef) {
    }
}
